import React from "react";
import "../../styles/Hero/Side.css";
import { useState } from "react";
// import Languages from "./Languages";
import { useTranslation } from "react-i18next";
import {Link} from 'react-router-dom'
export default function Side() {
  const {t} = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const display = () => {
    setIsVisible(!isVisible);
  };


  return (
    <section className="Menu-container">
      <span onClick={display} className="btn-open">
        <i className="fa-solid fa-bars-staggered"></i>
      </span>
      {isVisible && (
        <div className="Side--container" data-aos="fade-up">
          <div className="hamburger-nav-icon">
            <div className="btn-close" onClick={display}>
              <span>
                <i className="fa-solid fa-x"></i>
              </span>
            </div>
          </div>
          <div className="hamburger-nav-holder">
            <ul
              className="hamburger-nav-items"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <li className="hamburger-nav-item">
                <Link to="/">
                  <span>{t('Hero.Accueil')}</span>
                </Link>
              </li>
              <li className="hamburger-nav-item">
                <Link to="#/">
                  <span>{t('Hero.A_propos')}</span>
                </Link>
              </li>
              <li className="hamburger-nav-item">
                <Link to="#/">
                  <span>{t('Hero.Solutions')}</span>
                </Link>
              </li>
              <li className="hamburger-nav-item">
                <Link to="#/">
                  <span>{t('Hero.Activités')}</span>
                </Link>
              </li>
              <li className="hamburger-nav-item">
                <Link to="/contact-us">
                  <span>Contact</span>
                </Link>
              </li>
              <li className="hamburger-nav-item">
                <Link to="/support">
                  <span>Support</span>
                </Link>
              </li>
              <li className="hamburger-nav-item">
                <a
                  href="https://gps.afrogotech.ma/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>{t('Hero.Espace_client')}</span>
                </a>
              </li>
              {/* <li className="hamburger-nav-item languages-item">
                <a href="#/ ">
                <Languages/>
                </a>
              </li> */}
            </ul>
          </div>
          <div className="hamburger-nav-information">
          <div className="information-bureau">
            <h3>{t('contactInfo.Informations')}</h3>
            <p>{t('contactInfo.Informations_paragraph')}</p>
            <p>N° 306, 10 Rue Ghandi,<br/>Rabat 10000</p>
          </div>
          <div className="support">
            <h3>Support</h3>
            <p>+212 (0) 5 30 16 47 99</p>
            <p>support@afrogotech.ma<br/>contact@afrogotech.ma</p>
          
          </div>
          </div>
        </div>
      )}
    </section>
  );
}
